// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/assets/';

export const apiUrl = 'https://tanuraaga.in/apibackend/apis/';
export const assetsUrl = 'https://tanuraaga.in/apibackend/assets/';